import { z } from 'zod';

export const userRoleSchema = z.enum(['ADMIN', 'DIJITIZER', 'ADVISER', 'USER']);
export type UserRole = z.infer<typeof userRoleSchema>;

/**
 * `Permission` strings are produced by the backend's `@Scopes(...)` decorator
 * and use the format `<module>:<action>` (e.g. `affiliates:read`).
 * The full list lives on the server; the client treats them as opaque strings.
 */
export const permissionSchema = z.string();
export type Permission = z.infer<typeof permissionSchema>;

export const userSchema = z.object({
  id: z.string(),
  email: z.email(),
  fullName: z.string(),
  role: userRoleSchema,
  scopes: z.array(permissionSchema).default([]),
  branchId: z.string().nullable().default(null),
  isActive: z.boolean().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export type User = z.infer<typeof userSchema>;

export const ROLE_LABELS: Record<UserRole, string> = {
  ADMIN: 'Administrador',
  DIJITIZER: 'Digitador',
  ADVISER: 'Asesor',
  USER: 'Usuario',
};
